import AFRAME from "aframe";
import * as device from "../js/device";
import jQuery from "jquery";

const $ = jQuery;

AFRAME.registerSystem('position', {
    init: function () {
    },
    _between: function (number, min, max) {
        number = Math.min(number, max);
        number = Math.max(number, min);
        return number;
    },

    fromSky: function (element, skyPosition, distanceFromOrigin) {
        const cameraPosition = device.getCameraPosition();

        const s = new THREE.Spherical();
        s.setFromVector3(skyPosition);
        s.radius = distanceFromOrigin;

        const newPosition = new THREE.Vector3();
        newPosition.setFromSpherical(s);
        newPosition.y += 1.6;

        element.setAttribute('position', newPosition);
        element.object3D.lookAt(cameraPosition);
    },
    nearPosition: function (element, distance, position) {
        const cameraPosition = device.getCameraPosition();

        const s = new THREE.Spherical();
        s.setFromVector3(position);
        s.phi = Math.PI / 2;
        s.radius = distance;

        const newPosition = new THREE.Vector3();
        newPosition.setFromSpherical(s);
        newPosition.add(cameraPosition);

        element.setAttribute('position', newPosition);
        element.object3D.lookAt(cameraPosition);
    },
    beforeCamera: function (element, distance) {
        const cameraPosition = device.getCameraPosition();
        const cameraRotation = device.getCameraRotation();

        const newPosition = new THREE.Vector3(0, 0, -distance);
        newPosition.applyQuaternion(cameraRotation);
        newPosition.add(cameraPosition);

        element.setAttribute('position', newPosition);
        element.object3D.lookAt(cameraPosition);
    },
    beforeCameraClamped: function (element, distance) {
        const cameraPosition = device.getCameraPosition();
        const cameraRotation = device.getCameraRotation();

        const newPosition = new THREE.Vector3(0, 0, -distance);
        cameraRotation.x = 0;
        cameraRotation.z = 0;
        newPosition.applyQuaternion(cameraRotation);
        newPosition.add(cameraPosition);

        element.setAttribute('position', newPosition);
        element.object3D.lookAt(cameraPosition);
    },
    aboveElement: function (element, aboveElement) {

        const abovePosition = aboveElement.object3D.getWorldPosition(new THREE.Vector3());

        const test = new THREE.Spherical();
        test.setFromVector3(abovePosition);
        test.radius -= 0.05;
        test.phi -= 0.1;

        const test2 = new THREE.Vector3();
        test2.setFromSpherical(test);

        element.setAttribute('position', test2);
        element.object3D.lookAt(device.getCameraPosition());
    }
});

AFRAME.registerComponent('home-panel-position', {
    dependencies: ['rotation', 'position'],
    schema: {
        camera: {type: 'selector', default: ''},
    },
    tick: function () {
        const scene = document.querySelector('a-scene');

        this.el.setAttribute('position',{
            x: scene.camera.el.getAttribute('position').x + 0.8,
            y: scene.camera.el.getAttribute('position').y * 0.6,
            z: scene.camera.el.getAttribute('position').z - 0.1,
        });
    },
});

AFRAME.registerComponent('rotate-towards', {
    dependencies: ['rotation', 'position'],
    schema: {type: 'vec3'},
    update: function () {
        if (this.data) {
            const angleDeg2 = Math.atan2(this.data.x - 0, this.data.z - 0) * 180 / Math.PI;
            this.el.setAttribute('rotation', {
                y: 180 + angleDeg2,
            });
        }
    },
});

AFRAME.registerComponent('position-before-camera', {
    dependencies: ['position'],
    schema: {
        distance: {type: 'number', default: 1}
    },
    init: function () {
    },
    tick: function () {
        const scene = document.querySelector('a-scene');
        const positionHelper = scene.systems['position'];
        positionHelper.beforeCamera(this.el, 1);
    },
});

AFRAME.registerComponent('position-before-camera-clamped', {
    dependencies: ['position'],
    schema: {
        distance: {type: 'number', default: 1},
    },
    init: function () {
    },
    tick: function () {
        const scene = document.querySelector('a-scene');
        const positionHelper = scene.systems['position'];
        positionHelper.beforeCameraClamped(this.el, this.data.distance);
    },
});

AFRAME.registerComponent('position-from-sky', {
    dependencies: ['position'],
    schema: {
        skyPosition: {type: 'vec3'},
        distance: {type: 'number', default: 2},
    },
    init: function () {
        const me = this;
        const scene = document.querySelector('a-scene');

        $('a-scene').on('scene-updated', function(e) {
            me.forceUpdate();
        });

    },
    update: function () {
        this.forceUpdate();
    },
    forceUpdate: function() {
        const scene = document.querySelector('a-scene');
        const positionHelper = scene.systems['position'];
        positionHelper.fromSky(this.el, this.data.skyPosition, this.data.distance);
    }
});